//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from "../pureForm/FMPSelect";
import {valueToDisplay} from "../../libs/products";

class FMPProductSelect extends PureComponent {
	render () {
		const {
			label, value, path, onChange,
			error, helpText, md, productTypes, disabled,
			contained
		} = this.props;

		const options = productTypes.map(productType => {
			return { value : productType, display : valueToDisplay(productType) };
		});

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				md={md}
				helpText={helpText}
				disabled={disabled}
				contained={contained}
			/>
		);
	}
}

FMPProductSelect.propTypes = {
	label : PropTypes.string,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,
	error : PropTypes.string,

	classes : PropTypes.object,
	md : PropTypes.number,
	helpText : PropTypes.string,
	productTypes : PropTypes.array,
	disabled : PropTypes.bool,

	dataDumpMap : PropTypes.object,
	contained : PropTypes.bool,
};

FMPProductSelect.defaultProps =  {
	md : 12,
	label : 'Select fuel type',
};

export default FMPProductSelect;